import { Outlet } from 'react-router-dom'

import { GeneralProvider } from '@contexts'

const DashboardRouter = () => {
  return (
    <GeneralProvider>
      <Outlet />
    </GeneralProvider>
  )
}

export default DashboardRouter
